import { arrayMove } from '@dnd-kit/sortable';

/** dnd-kit の UniqueIdentifier と同じ。over が無いドラッグのために null も受ける */
type DragId = string | number | null | undefined;

/**
 * ドラッグの結果を並びに反映する。停車地と回転の両方が使う。
 *
 * Why 動かないドラッグで null: 掴んで放しただけでも onDragEnd は来る。
 * そこで並びを作り直すと、保存の debounce が起きて自動配車が空振りで走る。
 */
export function reorderByKey<T>(
  items: readonly T[],
  keyOf: (item: T) => string | number,
  activeId: DragId,
  overId: DragId,
): T[] | null {
  if (activeId === overId) return null;

  // 落とし先が無いドラッグ (over が null) もここで落ちる。
  // keyOf は string | number しか返さないので null とは一致しない
  const from = items.findIndex((it) => keyOf(it) === activeId);
  const to = items.findIndex((it) => keyOf(it) === overId);
  if (from < 0 || to < 0) return null;

  // arrayMove は元配列を複製して返す (sortable.cjs.development.js:15-19)。
  // [...items] は readonly を外すためだけで、防御的コピーではない
  return arrayMove([...items], from, to);
}
